import React from 'react';

import { RadiosField, MCButton, AsyncSelectField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import constants from 'src/constants';

import { lang, remCss, upperFirstChar } from 'src/helpers';

import model from '../modifyModel';

class AddPatientSlot extends BaseComponent {
  state = { type: 'virtual', hospitals: [] };
  componentDidMount() {
    model.subscribe(this.subscription);
    if (model.state.user?.isClinic && this.props.item) {
      this.setState({
        hospitalId: this.props.item.hospitalId,
        hospital: this.props.item.hospital,
        cityAddress: this.props.item.cityAddress
      });
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  confirm = () => {
    if (this.state.type === 'in_office' && !this.state.hospital) {
      this.setState({ invalid: { hospital: 'Hospital is required.' } });
      return;
    }
    const { item, index } = this.props;
    const patientSlot = {
      ...item,
      index,
      appointmentType: this.state.type,
      hospital: this.state.hospital,
      hospitalId: this.state.hospitalId,
      cityAddress: this.state.cityAddress
    };
    model.setState({
      selectedSlot: patientSlot
    });
    this.props.hide();
  };

  render() {
    const { item } = this.props;
    const { closeBtn } = this.props;
    const { invalid } = this.state;
    return (
      <div className='mc-popup-contain' style={{ width: remCss(300) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t('Add patient')}</div>
          {closeBtn}
        </div>
        <div className='mc-modal-body'>
          <div className={'mc-flex-col'}>
            <div className={'mc-flex'}>
              <RadiosField
                template={'2'}
                list={constants.general.appointment_types.filter(
                  (i) => item.appointmentTypes.indexOf(i.value) > -1
                )}
                data={this.state.type}
                onChange={(type) => this.setState({ type })}
              />
            </div>
            {this.state.type === 'in_office' &&
              (model.state.user?.isClinic ? (
                <div className={'mc-value-520'}>
                  {this.state.hospital?.split('_')[0]}, {upperFirstChar(this.state.cityAddress)}
                </div>
              ) : (
                <AsyncSelectField
                  template={5}
                  isClearable={true}
                  apiConfig={{
                    url: 'hospital/list',
                    labelKey: 'hospital'
                  }}
                  placeholder={'Hospital'}
                  name={'hospitalId'}
                  invalid={invalid}
                  value={this.state.hospitalId}
                  onChange={(n, v, option) => {
                    if (v?.toString() === this.state.hospital?.toString()) return;
                    this.setState({
                      hospitalId: v,
                      hospital: option.label,
                      cityAddress: option?.item?.city
                    });
                  }}
                />
              ))}
          </div>
        </div>
        <div className='mc-modal-footer mc-flex-20'>
          <MCButton primary light radius medium flex onClick={this.props.hide}>
            {lang.t('Back')}
          </MCButton>
          <MCButton primary dark radius medium flex onClick={this.confirm}>
            {lang.t('Add')}
          </MCButton>
        </div>
      </div>
    );
  }
}

export default AddPatientSlot;
